module.exports = __webpack_public_path__ + "static/media/8_shape_l.580fe34d.webp";